export const OPCD_QUERIES_LIST_ENDPOINT =
  "/arcplus/outpatient/pro-fee/queries";

export const OPCD_QUERY_DETAIL_ENDPOINT = (queryId: string) =>
  `${OPCD_QUERIES_LIST_ENDPOINT}/${queryId}`;

export const OPCD_QUERY_RESPONSE_ENDPOINT = (queryId: string) =>
  `${OPCD_QUERY_DETAIL_ENDPOINT(queryId)}/response`;

export const OPCD_HIM_ALERTS_ENDPOINT =
  "/arcplus/outpatient/pro-fee/him-checklist-errors";

export const OPCD_HIM_ALERT_ACKNOWLEDGE_ENDPOINT = (alertId: string) =>
  `${OPCD_HIM_ALERTS_ENDPOINT}/${encodeURIComponent(alertId)}/acknowledge`;

export const GET_OUTPATIENT_PRO_FEE_AUDIT_ALERTS_ENDPOINT =
  "/arcplus/emr/v1/outpatient/pro-fee/audit-alerts";

export const GET_OUTPATIENT_PRO_FEE_CODING_RESULTS_ENDPOINT =
  "/arcplus/emr/v1/outpatient/pro-fee/coding-results";
